import { useRef } from 'react';
import useScrollPosition from '@/hooks/browser/useScrollPosition';

const useScrollReachedElement = ({
  scrollElement,
  debounceTime = 250,
  topOffset = 0,
  measureFromTopOfPage = false
} = {}) => {
  const { scrollY, resetScroll } = useScrollPosition({
    element: scrollElement,
    debounceTime
  });
  const intersectionElementRef = useRef(null);

  let topScroll;
  const intersectionElement = intersectionElementRef.current;
  
  if (measureFromTopOfPage && intersectionElement) {
    topScroll = (intersectionElement).getBoundingClientRect().top;
  } else if (!measureFromTopOfPage) {
    topScroll = (intersectionElement || {}).offsetTop;
  }
  
  const distanceToIntersection = (topScroll ? ((topScroll || 0) - topOffset) : 100000) - (measureFromTopOfPage ? 0 : scrollY);

  const hasIntersected = (distanceToIntersection < 10);

  return {
    ref: intersectionElementRef,
    hasIntersected,
    resetScroll
  };
};

export default useScrollReachedElement;